<template>
  <!-- 筛选-->
  <FilterHeader ref="filterHeader"
                :total="total"
                :facet-list="facetList"
                :showFilterParams="showFilterParams"
                @deleteFilterParams="deleteFilterParams"
                @getFilterParams="getFilterParams"/>
  <!--最新上架-->
  <BookBlock :list="newList" @onLoad="onLoad" ref="bookChild"/>
</template>

<script>
import {defineComponent, onMounted, ref} from "vue";
import BookBlock from './BookBlock';
import {FilterHeader, FilterPopup} from '../components/common';
import {getLatest} from '@/api/books';
import {isNotEmpty, setCovers} from '@/utils/util';

export default defineComponent({
  name: 'NewArrival',
  components: {
    BookBlock,
    FilterPopup,
		FilterHeader
  },
  setup() {
    const newList = ref([]);
    const bookChild = ref();
    const total = ref(0);
    let page = 1;
		// 过滤值
    const filterHeader = ref();
		const facetList = ref([]);
		const showFilterParams = ref([]);
		let filterParams = null;

    onMounted(() => {
      onLatest();
    });

    const onLatest = () => {
      let params = filterParams ? new URLSearchParams(filterParams) : new URLSearchParams();
      params.append('page', page);
      params.append('pageSize', '10');
      getLatest(params)
          .then(data => {
            if (data) {
							const isbns = [];
              total.value = data.total;
              if (isNotEmpty(data.dataList)) {
                data.dataList.forEach(item => {
                  if (isNotEmpty(item.isbn)) {
                    isbns.push(item.isbn);
                  }
                  Object.assign(item, {bookId: item.bookid})
                });
                if (isNotEmpty(isbns)) {
									setCovers(isbns, data.dataList);
                }
                newList.value = newList.value.concat(data.dataList);
              }
              page++;
              facetList.value = data.facetList ?? [];
            }
            if (isNotEmpty(bookChild.value)) {
              bookChild.value.loading = false; // 加载状态结束
              bookChild.value.finished = newList.value.length >= total.value;
            }
          })
          .catch((error) => {
            console.error(error);
          });
    };
    const onLoad = () => {
      if (newList.value.length < total.value) {
        onLatest();
      } else {
        bookChild.value.loading = false; // 加载状态结束
        bookChild.value.finished = newList.value.length >= total.value;
      }
    };

		// 处理过滤条件
		const getFilterParams = (params,showParams) => {
			filterParams = params;
			showFilterParams.value = showParams;
			page =1;
      newList.value =[];
      onLatest();
		}
		// 删除过滤条件
		const deleteFilterParams = (key)=>{
			showFilterParams.value = showFilterParams.value.filter(item => item.code !==key);
			if(key ==='yearStartEnd'){
				filterParams.delete('startPublicationYear');
				filterParams.delete('endPublicationYear');
			}
			else{
				filterParams.delete(key);
			}
      if (showFilterParams.value.length === 0) {
        filterHeader.value?.resetPop(); // 清空筛选条件的选择
      }
			page =1;
      newList.value =[];
      onLatest();
		}

    return {
      newList,
      bookChild,
      total,
      onLoad,
			facetList,
			showFilterParams,
			getFilterParams,
			deleteFilterParams,
      filterHeader
    }
  },
});
</script>

<style scoped lang="less">
</style>
